// extracted by mini-css-extract-plugin
export default {"box":"BorderBox_box__Ej3M3","boxBorder":"BorderBox_boxBorder__6PhJB"};